/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Asset } from './Asset';
import {
    AssetFromJSON,
    AssetFromJSONTyped,
    AssetToJSON,
    AssetToJSONTyped,
} from './Asset';

/**
 * 
 * @export
 * @interface FetchAssetFromUrlResponse
 */
export interface FetchAssetFromUrlResponse {
    /**
     * 
     * @type {Asset}
     * @memberof FetchAssetFromUrlResponse
     */
    asset?: Asset;
    /**
     * 
     * @type {string}
     * @memberof FetchAssetFromUrlResponse
     */
    cdnUrl?: string;
}

/**
 * Check if a given object implements the FetchAssetFromUrlResponse interface.
 */
export function instanceOfFetchAssetFromUrlResponse(value: object): value is FetchAssetFromUrlResponse {
    return true;
}

export function FetchAssetFromUrlResponseFromJSON(json: any): FetchAssetFromUrlResponse {
    return FetchAssetFromUrlResponseFromJSONTyped(json, false);
}

export function FetchAssetFromUrlResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FetchAssetFromUrlResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'asset': json['asset'] == null ? undefined : AssetFromJSON(json['asset']),
        'cdnUrl': json['cdnUrl'] == null ? undefined : json['cdnUrl'],
    };
}

export function FetchAssetFromUrlResponseToJSON(json: any): FetchAssetFromUrlResponse {
    return FetchAssetFromUrlResponseToJSONTyped(json, false);
}

export function FetchAssetFromUrlResponseToJSONTyped(value?: FetchAssetFromUrlResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'asset': AssetToJSON(value['asset']),
        'cdnUrl': value['cdnUrl'],
    };
}

